import {ILanguageState} from '@app/shared/models/language.model';
import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';

export const selectLanguageState = createFeatureSelector<ILanguageState>(EState.Language);

export const selectActiveLanguages = createSelector(selectLanguageState, state =>
  state.languages.filter(language => language.enabled === true)
);

export const selectSelectedLanguage = createSelector(selectLanguageState, state =>
  state?.languages.find(language => language.id?.toString() == state.selectedLanguage)
);
